import React, { Component } from "react";
import { Button, Card, Col, Row, Select as AntdSelect } from "antd";
import Spin from "../../../../../../components/common/Spin";
import PropTypes from "prop-types";
import validate from "./validate";
import asyncValidate from "./asyncValidate";
import { reduxForm, Field, isPristine, getFormValues } from "redux-form";
import { connect } from "react-redux";
import { Text, Date, Cascader, Select } from "components/redux-form";
import MaterialIcon from "../../../../../../components/common/MaterialIcon";
import {
  emptyRule,
  emptyRulePackRule,
  showForm,
} from "../../../../Requests/Pattern/RulePack/Module";

import { createReport, updateReport, getNewReport } from "./../../Module";
import ExtraColumns from "./common/ExtraColumns";
import RangeDate from "./common/RangeDate";
import Position from "../../../../../../components/FormBuilder/common/Position/Position";
import Recruitment from "../../../../../../components/FormBuilder/common/Recruitment/Recruitment";
import AddColumns from "./common/AddColumns";
import { store, update } from "../../../Policy/Definition/Module";
import moment from "moment-jalaali";
import Personnel from "../../../../Basic/Personnel/Personnel";
import PersonnelList from "../../../../../../components/classes/Assignment/components/PersonnelList";
import Users from "../../../../../../components/FormBuilder/common/Users/Users";

@reduxForm({
  form: "reports-addReport-form",
  validate,
  asyncValidate,
  onSubmit: (values, dispatch, props) => {
    let dateFrom = values.dateFrom;
    let dateTo = values.dateTo;
    if (values.range) {
      //     dateFrom = moment().format('YYYY/MM/DD');
      //     dateTo = moment(
      //         moment().subtract( values.range.substr(0 , 1), values.range.substr(1, values.range.length))
      //     ).format( 'YYYY/MM/DD')
      //     dateFrom = null;
      //     dateTo = null;
    }
    const data = {
      report_type: {
        name: values.name,
        headers: values.headers,
        form: {
          range: values.range,
          date_from: dateFrom,
          date_to: dateTo,
          type: values.type,
          factors: values.factors,
          positions: values.positions,
          report_type: values.reportType,
          factor_column_types: values.factorColumnTypes,
          sort_by: values.sortBy,
          recruitment_types_id: values.recruitmentTypesId,
        },
      },
    };

    if (props.reportId) {
      dispatch(
        updateReport(props.reportId, data, (err, res) =>
          props.handleSubmit(res.data.reportType)
        )
      );
    } else {
      dispatch(createReport(data, (err, res) => props.handleSubmit(res.data)));
    }
  },
})
@connect(
  (state) => ({
    rulePackRule: state.Requests.Pattern.RulePack.rulePackRule,
    rule: state.Requests.Pattern.RulePack.rule,
    newReport: state.Attendance.Reports.newReport,
    values: getFormValues("reports-addReport-form")(state),
  }),
  {
    getNewReport,
    showForm,
    emptyRule,
    emptyRulePackRule,
  }
)
@autobind
class ReportBuilder extends Component {
  static propTypes = {
    onCancel: PropTypes.func,
    title: PropTypes.string,
    loading: PropTypes.bool,
    reportId: PropTypes.number,
  };

  static defaultProps = {
    onCancel: () => {},
    title: "add report",
    loading: false,
    reportId: undefined,
  };

  constructor(props) {
    super(props);

    this.state = {
      // types: [],
    };
  }

  componentDidMount() {
    // this.setState({types: Types.items("WorkingHour.Rules")});
    // this.props.show(3);

    // const initialize = this.state.initialize;
    const { reportId, showForm, getNewReport } = this.props;

    if (reportId) {
      // if (!initialize) {
      this.setState({ initialize: true }, () => getNewReport(reportId));
      // } else {
      //     this.setState({ initialize: false });
      //     this.props.initialize(this.props.data);
      // }
      // } else {
      //     this.setState({ initialize: false });
    }

    // showForm({
    //     includes: ['form.fields'],
    // });
  }

  // initialParams = () => {
  //     return {
  //         reportType: {
  //             "name": "گزارش روزانه",
  //             "headers": '',
  //             "form": {
  //                 "date_from": "2021-01-31",
  //                 "date_to": "2021-02-03",
  //                 "type": "daily",
  //                 "factors": {
  //                     "activity": "عملکرد",
  //                     "daily_absence": "غیبت روزانه",
  //                     "hurry": "تعجیل",
  //                     "delay": "تاخیر"
  //                 },
  //                 "positions": [561],
  //                 "report_type": "24hours",
  //                 "factor_column_types": "minute",
  //                 "sort_by": "personnelId",
  //                 "recruitment_types_id": ["1"]
  //             }
  //         }
  //     }
  // }

  // createReport = () => {
  //     // let {values , createOrUpdateReport, onSubmit} = this.props;
  //     // createOrUpdateReport(values);
  //     // this.props.submit('reports-addReport-form')
  // }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.newReport !== this.props.newReport) {
      if (this.props.reportId) {
        let { newReport } = this.props;
        let { name, form, headers } = newReport;
        // let headersStr = headers && headers[0] && headers.join(',');
        let values = { name, ...form, headers };
        this.props.initialize(values);
      }
    } else if (prevProps.reportId !== this.props.reportId) {
      if (this.props.reportId) {
        this.props.getNewReport(this.props.reportId);
      } else {
        this.props.initialize({});
      }
    }
  }

  /**
   *
   * @param {Object[]} groups
   * @return {Object[]}
   * @private
   */
  _renderGroups(groups) {
    let _groups = [];
    groups.forEach((group) => {
      let _group = {
        value: group.id,
        label: group.label,
      };

      if (!app._.isEmpty(group.children)) {
        _group.children = this._renderGroups(group.children);
      }

      _groups.push(_group);
    });
    return _groups;
  }

  render() {
    let {
      loading,
      onCancel,
      title,
      values,
      submit,
      pristine,
      submitting,
      reportId,
    } = this.props;
    let factors = [];
    if (!app._.isEmpty(this.state.types)) {
      factors = this._renderGroups(this.state.types);
    }
    return (
      <Card
        className="wrapper"
        title={title}
        extra={
          <Button.Group>
            <Button type="default" onClick={() => onCancel()}>
              {app.translate("main.Cancel")}
            </Button>
            <button
              disabled={submitting}
              className="ant-btn ant-btn-primary"
              onClick={submit}
            >
              <span>
                {app.translate(
                  reportId ? "ویرایش " : "routes.home.attendance.reports.Add"
                )}{" "}
              </span>
            </button>
          </Button.Group>
        }
      >
        <Spin spinning={loading}>
          <div
            style={{
              width: "100%",
              height: "calc(100% - 40px)",
            }}
          >
            <Row
              style={{
                height: "100%",
                marginBottom: "9px",
              }}
            >
              {app.haveUiPermission(["ReportBuilder"]) && (
                <Col sm={24}>
                  <Field
                    name="name"
                    label={app.translate(
                      "routes.home.attendance.reports.Report Name"
                    )}
                    prefix={<MaterialIcon name="alphabetical" />}
                    required
                    component={Text}
                  />
                </Col>
              )}

              <Col sm={24}>
                <Field
                  name="range"
                  label={app.translate(
                    "routes.home.attendance.reports.Report range date"
                  )}
                  prefix={<MaterialIcon name="calender" />}
                  component={RangeDate}
                />
              </Col>

              {this.props.values && !this.props.values.range && (
                <Col sm={24}>
                  <Field
                    style={
                      this.props.values &&
                      this.props.values.range && { opacity: "0.5" }
                    }
                    name="dateFrom"
                    label={app.translate(
                      "routes.home.attendance.reports.Report Date from"
                    )}
                    prefix={<MaterialIcon name="calender" />}
                    required
                    max={this.props.values && this.props.values.dateTo}
                    defaultValue={moment(moment().subtract(1, "months")).format(
                      "YYYY/MM/DD"
                    )}
                    component={Date}
                  />
                </Col>
              )}

              {this.props.values && !this.props.values.range && (
                <Col sm={24}>
                  <Field
                    style={
                      this.props.values &&
                      this.props.values.range && { opacity: "0.5" }
                    }
                    name="dateTo"
                    label={app.translate(
                      "routes.home.attendance.reports.Report Date to"
                    )}
                    prefix={<MaterialIcon name="calender" />}
                    min={this.props.values && this.props.values.dateFrom}
                    defaultValue={moment().format("YYYY/MM/DD")}
                    required
                    component={Date}
                  />
                </Col>
              )}

              {app.haveUiPermission(["ReportBuilder"]) && (
                <Col sm={24}>
                  <Field
                    name="type"
                    label={app.translate(
                      "routes.home.attendance.reports.Report type"
                    )}
                    defaultValue={"daily"}
                    required
                    component={Select}
                  >
                    <AntdSelect.Option value="daily">
                      {app.translate(
                        "routes.home.attendance.reports.Report daily"
                      )}
                    </AntdSelect.Option>
                    <AntdSelect.Option value="total">
                      {app.translate(
                        "routes.home.attendance.reports.Report total"
                      )}
                    </AntdSelect.Option>
                  </Field>
                </Col>
              )}

              {app.haveUiPermission(["ReportBuilder"]) && (
                <Col sm={24}>
                  <Field
                    name="headers"
                    // type={'array'}
                    // defaultValue={this.props.values && this.props.values.headers}
                    label={app.translate(
                      "routes.home.attendance.reports.Report columns"
                    )}
                    // required
                    reportType={this.props.values && this.props.values.type}
                    selectedHeaders={
                      this.props.values && this.props.values.headers
                    }
                    type={"text"}
                    component={ExtraColumns}
                    // defaultValue={this.props.values && this.props.values.headers}
                  />
                </Col>
              )}

              <Col sm={24} md={24}>
                <Field
                  name="positions"
                  label={app.translate(
                    "routes.home.attendance.reports.Report positions"
                  )}
                  // required
                  component={Position}
                />
              </Col>
              {/*<Col sm={24}>*/}
              {/*    <Field*/}
              {/*        name="recruitment_types_id"*/}
              {/*        label={app.translate('routes.home.attendance.reports.Report recruitment_type_id')}*/}
              {/*        // required*/}
              {/*        component={Recruitment}*/}
              {/*    />*/}
              {/*</Col>*/}
              {app.haveUiPermission(["ReportBuilder"]) && (
                <Col sm={24}>
                  <Field
                    name="sortBy"
                    label={app.translate(
                      "routes.home.attendance.reports.Report sort_by"
                    )}
                    defaultValue={"personnelId"}
                    component={Select}
                  >
                    <AntdSelect.Option value="name">
                      {app.translate(
                        "routes.home.attendance.reports.Report name"
                      )}
                    </AntdSelect.Option>
                    <AntdSelect.Option value="family">
                      {app.translate(
                        "routes.home.attendance.reports.Report family"
                      )}
                    </AntdSelect.Option>
                    <AntdSelect.Option value="personnelId">
                      {app.translate(
                        "routes.home.attendance.reports.Report personal_id"
                      )}
                    </AntdSelect.Option>
                  </Field>
                </Col>
              )}

              {app.haveUiPermission(["ReportBuilder"]) && (
                <Col sm={24}>
                  <Field
                    name="reportType"
                    label={app.translate(
                      "routes.home.attendance.reports.Report report_type"
                    )}
                    defaultValue={"24hours"}
                    required
                    component={Select}
                  >
                    <AntdSelect.Option value="24hours">
                      {app.translate(
                        "routes.home.attendance.reports.Report day_base"
                      )}
                    </AntdSelect.Option>
                    <AntdSelect.Option value="working_hour">
                      {app.translate(
                        "routes.home.attendance.reports.Report working_hour_base"
                      )}
                    </AntdSelect.Option>
                  </Field>
                </Col>
              )}

              {app.haveUiPermission(["ReportBuilder"]) && (
                <Col sm={24} md={24} lg={24} xl={24}>
                  <Field
                    name="factors"
                    label={app.translate(
                      "routes.home.attendance.reports.Report factors"
                    )}
                    // prefix={<MaterialIcon name="calender" />}
                    // required
                    items={factors}
                    component={AddColumns}
                  />
                </Col>
              )}
            </Row>
          </div>
        </Spin>
      </Card>
    );
  }
}

export default ReportBuilder;
